
import { MessageMetadata } from "@/types/message";

/**
 * Prepares metadata for AI response regeneration
 */
export const prepareRegenerationMetadata = (
  data: any,
  originalMessageId: string,
  customInstructions?: string
): MessageMetadata => {
  return {
    sentiment: data.sentiment,
    suggestedTone: data.suggestedTone,
    exchangeCount: data.metrics?.exchangeCount,
    responseTimeHours: data.metrics?.responseTimeHours,
    refundApproved: data.refundApproved,
    customInstructions: customInstructions,
    relatedMessageId: originalMessageId // Track which message is being regenerated
  };
};
